// check session storage is supported
if (!window.sessionStorage) {
	window.console && window.console.error && window.console.error('SafeRedirect Tips: your browser does not support session storage!');
}

import PageInfoManager from './core/pageinfo-manager';
import SafeRedirect from './safe-redirect';
import Config from './config';

const currentPageInfo: PageInfoManager = new PageInfoManager();

interface InitConfig {
	isJump?: boolean;
	customInfo?: Record<string, any>;
	domainBlackList?: string[];
	rules?: any;
	errorTipsPageUrl?: string;
	errorTipsPageQuery?: Record<string ,any>;
	disableRequestInterceptor?: boolean;
	reporter?: Record<string, any>
}

function init (config: InitConfig = {}) {
	Config.isJump = config.isJump || false;
	Config.domainBlackList = config.domainBlackList || [];
	Config.rules = config.rules || {};
	Config.errorTipsPageUrl = config.errorTipsPageUrl || '';
	Config.errorTipsPageQuery = config.errorTipsPageQuery || {}
	Config.reporter = config.reporter || null;
	Config.disableRequestInterceptor = config.disableRequestInterceptor === false ? false : true;
	currentPageInfo.setCustomInfo(config.customInfo);
	SafeRedirect.safeRedirect(currentPageInfo, Config.errorTipsPageQuery);
}

window._safeRedirect = {
	init
};

export default window._safeRedirect;
